import BaseAreaStack from "./private/BaseAreaStack.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default function AreaStack(props) {
  return /*#__PURE__*/_jsx(BaseAreaStack, {
    ...props
  });
}